import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  root: {
    backgroundColor: 'peachpuff',
    border: '1px darkmagenta dashed',
    width: '100%',
    minHeight: 200,
    textAlign: 'center',
    paddingTop: 50
  }
})

export {
  useStyles
}
